import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {AppAction, IAppState} from '../../store/interfaces/IAppState';
import {ActionHandler} from '../../store/action.handler';
import {NgRedux} from '@angular-redux/store';
@Directive({
  selector: '[whenAnyAction]'
})
export class WhenActionProgressDirective implements OnInit {
  private hasView = false;
  state: IAppState;
  @Input()
  whenAnyAction: AppAction[];
  @Input()
  whenAnyActionInProgress = true;
  @Input()
  whenAnyActionCompletedWithError = true;
  @Input()
  whenAnyActionCompletedSuccessfully = true;
  @Input()
  whenAnyActionByDefault = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _ngRedux: NgRedux<IAppState>) { }

  ngOnInit() {
    this.updateFromState();
    this.updateView(this.whenAnyActionByDefault);
    this._ngRedux.subscribe(() => {
      this.updateFromState();
    });
  }
  updateFromState() {
    this.state = this._ngRedux.getState();
    this.whenAnyAction.forEach(actionInProgress => {
      ActionHandler.handleInitial(this.state, actionInProgress, () => {
        this.updateView(this.whenAnyActionInProgress);
      });
      ActionHandler.handleError(this.state, actionInProgress, () => {
        this.updateView(!this.whenAnyActionInProgress && this.whenAnyActionCompletedWithError);
      });
      ActionHandler.handleSuccess(this.state, actionInProgress, () => {
        this.updateView(!this.whenAnyActionInProgress && this.whenAnyActionCompletedSuccessfully);
      });
    });
  }

  updateView(condition: boolean) {
    if (condition && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!condition && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/when-action-progress/when-action-progress.ts